import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { teamMembers } from '../mock';

const Team = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-gray-50 to-white py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-[#000053] mb-6">
              Meet Our Team
            </h1>
            <p className="text-xl text-[#36454F] mb-8">
              Experienced healthcare professionals dedicated to your well-being
            </p>
            <p className="text-lg text-gray-600">
              Our multidisciplinary team brings together expertise from various healthcare fields to provide you with comprehensive, coordinated care.
            </p>
          </div>
        </div>
      </section>

      {/* Team Members Grid */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {teamMembers.map((member) => (
              <Card key={member.id} className="hover:shadow-xl transition-all duration-300 border-2 hover:border-[#006D73]">
                <CardHeader>
                  {/* Team Member Photo or Avatar Placeholder */}
                  {member.photo ? (
                    <div className="w-32 h-32 rounded-full overflow-hidden mx-auto mb-4 border-4 border-[#006D73] border-opacity-20">
                      <img 
                        src={member.photo} 
                        alt={member.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  ) : (
                    <div className="w-32 h-32 bg-[#006D73] bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4 border-4 border-[#006D73] border-opacity-20">
                      <span className="text-3xl font-bold text-[#006D73]">
                        {member.name.split(' ').map(n => n[0]).join('')}
                      </span>
                    </div>
                  )}
                  <CardTitle className="text-center text-[#000053]">{member.name}</CardTitle>
                  <CardDescription className="text-center">
                    <span className="font-semibold text-[#006D73]">{member.role}</span>
                    <br />
                    <span className="text-gray-500 text-sm">{member.credentials}</span>
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 text-center text-sm leading-relaxed">{member.bio}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#000053]">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-white mb-6">
              Ready to Meet Our Team?
            </h2>
            <p className="text-gray-300 mb-8">
              Book an appointment today and experience the difference that compassionate, expert care can make.
            </p>
            <Link to="/book">
              <Button size="lg" className="bg-[#006D73] text-white hover:bg-[#005a5f] transition-all">
                Book an Appointment
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;